import { Collapse } from "antd"
import { CollapseBlueIcon } from "components/ui/icons/collapseIcon/CollapseBlueIcon"
import { CollapseGrayIcon } from "components/ui/icons/collapseIcon/CollapseGrayIcon"
import type { CollapseProps } from "antd"
import styles from "./CollapseJSON.module.scss"

const { collapseJSON } = styles

type Props = { items: CollapseProps["items"] }

export const CollapseJSON = ({ items }: Props) => {
	return (
		<Collapse
			className={collapseJSON}
			items={items}
			expandIcon={({ isActive }) =>
				isActive ? <CollapseBlueIcon rotate={isActive ? 90 : 0} /> : <CollapseGrayIcon rotate={isActive ? 90 : 0} />
			}
		/>
	)
}
